import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ReplaySubject } from "rxjs";

import { Briefing, HistoryEventType } from "app/shared/types";
import { groupBy } from "../../../utils";
import { Router } from "@angular/router";

@Component({
	selector: "ic-briefing-list",
	templateUrl: "./briefing-list.component.html",
	styleUrls: ["./briefing-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BriefingListComponent implements OnChanges {
	private readonly briefingHistory$ = new ReplaySubject<Briefing[]>(1);
	private readonly router = inject(Router);

	// @ts-expect-error TS2564
	@Input() briefings: Briefing[];

	groupedBriefings = [];

	ngOnChanges(changes: SimpleChanges) {
		if (changes.briefings) {
			this.briefingHistory$.next(this.briefings);

			const residentBriefingMap = groupBy(this.briefings || [], (briefing) => briefing.resident.id);

			// @ts-expect-error TS2322
			this.groupedBriefings = Array.from(residentBriefingMap.entries()).map(([, briefings]) => ({
				resident: briefings[0].resident,
				briefings,
			}));
		}
	}

	hasRoute(type: HistoryEventType) {
		return [
			HistoryEventType.MEDICATION_INCIDENT_ADMINISTER,
			HistoryEventType.MEDICATION_INCIDENT_PREPARE,
			HistoryEventType.MEDICATION_INCIDENT_VERIFY,
		].includes(type);
	}

	private navigateToAdministrationMedicationIncident(residentId: string, incidentId: string) {
		this.router.navigate([residentId, "medication", "administration-incident", "incidents", incidentId, "summary"]);
	}

	private navigateToVerifyAndPrepareMedicationIncident(
		residentId: string,
		incidentId: string,
		medicationId: string,
		incidentType: string,
	) {
		this.router.navigate([residentId, "medication", "verify-prepare-incident", incidentId, "summary"], {
			queryParams: { medicationId, incidentType },
		});
	}

	// @ts-expect-error TS7006
	showDetails(event) {
		switch (event.type) {
			case HistoryEventType.MEDICATION_INCIDENT_ADMINISTER:
				this.navigateToAdministrationMedicationIncident(event.resident.id, event.reference.incidentId);
				break;
			case HistoryEventType.MEDICATION_INCIDENT_PREPARE:
			case HistoryEventType.MEDICATION_INCIDENT_VERIFY:
				this.navigateToVerifyAndPrepareMedicationIncident(
					event.resident.id,
					event.reference.id,
					event.reference.medicationId,
					event.reference.incidentType,
				);
				break;
		}
	}
}
